import { Component, Inject, inject, OnInit } from '@angular/core';
import {
  FormArray,
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { BtnSubmitComponent } from '../../buttons/btn-submit/btn-submit.component';

@Component({
  selector: 'app-dlg-invite-code',
  standalone: true,
  imports: [ReactiveFormsModule, BtnSubmitComponent],
  templateUrl: './dlg-invite-code.component.html',
  styleUrl: './dlg-invite-code.component.css',
})
export class DlgInviteCodeComponent implements OnInit {
  readonly dialogRef = inject(MatDialogRef<DlgInviteCodeComponent>);

  title: string = 'Enter Invite Code';
  description: string = 'Invite code is required.';
  action: string = 'Ok';

  inviteForm: FormGroup;
  inputConfig: number[];
  showError = false;

  constructor(@Inject(MAT_DIALOG_DATA) public data: { codeLength: number }) {
    // Default to 4 if no length is provided, constrained between 4 and 6
    const length = Math.min(Math.max(data.codeLength || 4, 4), 6);
    this.inputConfig = Array(length).fill(0);

    this.inviteForm = new FormGroup({
      codes: new FormArray(
        this.inputConfig.map(
          () =>
            new FormControl('', [
              Validators.required,
              Validators.pattern(/^[A-Z0-9]$/),
            ]),
        ),
      ),
    });
  }

  get codes() {
    return this.inviteForm.get('codes') as FormArray;
  }

  ngOnInit(): void {}

  onInput(event: any, index: number) {
    this.showError = false;
    const val = event.target.value.toUpperCase();

    // Only allow A-Z and 0-9
    if (/^[A-Z0-9]$/.test(val)) {
      this.codes.at(index).setValue(val);
      // Auto-focus next input
      if (index < this.inputConfig.length - 1) {
        const nextInput = event.target.nextElementSibling as HTMLInputElement;
        nextInput?.focus();
      }
    } else {
      this.codes.at(index).setValue('');
    }
  }

  onKeyDown(event: KeyboardEvent, index: number) {
    this.showError = false;
    if (event.key === 'Backspace' && !this.codes.at(index).value && index > 0) {
      const prevInput = (event.target as HTMLInputElement)
        .previousElementSibling as HTMLInputElement;
      prevInput?.focus();
    }
  }

  onCancel() {
    this.dialogRef.close();
  }

  submit() {
    if (this.inviteForm.invalid) {
      this.showError = true;
      return;
    }

    const fullCode = this.codes.value.join('');
    this.dialogRef.close(fullCode);
  }
}
